<template>
  <performer-projects-layout :spinning="isLoading">
    <performer-project-layout :model="model">
      <template #underInfo>
        <div class="performer-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :show-percent="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>
      <project-stats
        :completed-count="model.completedCount"
        :completed-overdue-count="model.completedOverdueCount"
        :incomplete-count="model.incompleteCount"
        :incomplete-overdue-count="model.incompleteOverdueCount"
      />

      <task-item-list
        ref="incompleteTaskRef"
        :task-status="PROJECT_TASK_STATUS_ALL_INCOMPLETE"
        :project-status-id="model.projectStatusId"
        :user-id="model.userId"
        @update="onUpdate"
      >
        <template v-slot:header>
          <span
            >В работе /
            {{ model.incompleteCount + model.incompleteOverdueCount }}</span
          >
        </template>
      </task-item-list>

      <task-item-list
        ref="completedTaskRef"
        :task-status="PROJECT_TASK_STATUS_ALL_COMPLETED"
        :project-status-id="model.projectStatusId"
        :user-id="model.userId"
        @update="onUpdate"
      >
        <template v-slot:header>
          <span
            >Выполнено /
            {{ model.completedCount + model.completedOverdueCount }}</span
          >
        </template>
      </task-item-list>
    </performer-project-layout>
  </performer-projects-layout>
</template>

<script setup>
  import { computed, onMounted, reactive, ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import PerformerProjectsLayout from '../layouts/PerformerProjectsLayout.vue';
  import PerformerProjectLayout from '../layouts/PerformerProjectLayout.vue';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';
  import ProjectStats from '@/components/projects/management/ProjectStats.vue';
  import TaskItemList from '@/components/projects/management/TaskItemList.vue';
  import {
    PROJECT_TASK_STATUS_ALL_COMPLETED,
    PROJECT_TASK_STATUS_ALL_INCOMPLETE,
  } from '@/api/models/ProjectTaskStatus';

  const api = useApi();
  const route = useRoute();
  const model = reactive({
    id: null,
    projectStatusId: null,
    number: '',
    name: 'Новый проект',
    description: '',
    projectType: '',
    requestId: null,
    status: {
      type: 'draft',
      text: 'Черновик',
    },
    userId: null,
    showAllTasks: false,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });
  const completedTaskRef = ref(null);
  const incompleteTaskRef = ref(null);
  const isLoading = ref(true);

  const tab = computed(() => {
    return route.hash ? route.hash.replace('#', '') : 'my';
  });

  onMounted(async () => {
    await getModel();
    isLoading.value = false;
  });

  watch(
    () => route.hash,
    async () => {
      await getModel();
    }
  );

  const getModel = async () => {
    try {
      const response =
        tab.value === 'my'
          ? await api.performerPage.projectMyStats(route.params.id)
          : await api.performerPage.project(route.params.id);
      model.id = response.project.id;
      model.userId = response.project.userId;
      model.projectStatusId = response.project.projectStatusId;
      model.name = response.project.name;
      model.number = response.project.id;
      model.type = response.project.type;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.showAllTasks = response.project.showAllTasks;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };

  const onUpdate = async () => {
    await getModel();
    await completedTaskRef.value.updateTasks();
    await incompleteTaskRef.value.updateTasks();
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  h3 {
    color: $color-black;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.1;
  }

  .performer-project__common-progress {
    margin-top: 42px;
  }
</style>
